var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "info" },
                  on: { click: _vm.getOrderSummary }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "redo-alt" } }),
                  _vm._v(" Refresh")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3 mb-3" },
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c("b-card", [
                _c("h5", [_c("strong", [_vm._v("List Produk Stok")])]),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-striped" },
                  [
                    _c("tr", [
                      _c("th", [_vm._v("Name")]),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-center" }, [
                        _vm._v("Stok")
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-center" }, [
                        _vm._v("Min. Stok")
                      ]),
                      _vm._v(" "),
                      _c("th")
                    ]),
                    _vm._v(" "),
                    _vm.listProductSize.length > 0
                      ? _vm._l(_vm.listProductSize, function(productSize) {
                          return _c("tr", { key: productSize.id }, [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  productSize.product_color.product_categories
                                    .product.name
                                ) +
                                  " - \n                    " +
                                  _vm._s(
                                    productSize.product_color.product_categories
                                      .category.name
                                  ) +
                                  " - \n                    " +
                                  _vm._s(productSize.product_color.color.name) +
                                  " - \n                    " +
                                  _vm._s(productSize.size.name)
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(_vm._s(productSize.stock))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(_vm._s(productSize.min_stock))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "button",
                                      variant: "primary",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showModal(productSize)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "edit" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        })
                      : [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { colspan: "4" }
                              },
                              [_vm._v("Tidak ada untuk saat ini.")]
                            )
                          ])
                        ]
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xl-4 col-md-6" },
          [
            _c(
              "stats-card",
              { attrs: { title: _vm.model.member, subTitle: "Total Member" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "icon-warning",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_c("i", { staticClass: "nc-icon nc-paper-2 text-warning" })]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xl-4 col-md-6" },
          [
            _c(
              "stats-card",
              {
                attrs: {
                  title: _vm.model.spesial_member,
                  subTitle: "Total Spesial Member"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "icon-success",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_c("i", { staticClass: "nc-icon nc-badge text-success" })]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xl-4 col-md-6" },
          [
            _c(
              "stats-card",
              {
                attrs: {
                  title: _vm.model.pelanggan,
                  subTitle: "Total Pelanggan"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "icon-danger",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_c("i", { staticClass: "nc-icon nc-circle-09 text-danger" })]
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _vm.isLoading
                ? [
                    _c("font-awesome-icon", {
                      attrs: { icon: "spinner", spin: "" }
                    })
                  ]
                : [
                    _c(
                      "b-card",
                      [
                        _c("h5", [_c("strong", [_vm._v("Status Order")])]),
                        _vm._v(" "),
                        _c("apexchart", {
                          attrs: {
                            type: "donut",
                            height: "263",
                            options: _vm.chartOptions,
                            series: _vm.series
                          }
                        })
                      ],
                      1
                    )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c("b-row", [
                _c(
                  "div",
                  { staticClass: "col-xl-12 col-md-12" },
                  [
                    _c(
                      "stats-card",
                      {
                        attrs: {
                          title: _vm.model.dropshipper,
                          subTitle: "Total Dropshipper"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "icon-warning",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [
                            _c("i", {
                              staticClass:
                                "nc-icon nc-delivery-fast text-warning"
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xl-12 col-md-12" },
                  [
                    _c(
                      "stats-card",
                      {
                        attrs: {
                          title: _vm.model.gold_member,
                          subTitle: "Total Gold Member"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "icon-warning",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [
                            _c("i", {
                              staticClass:
                                "nc-icon nc-delivery-fast text-warning"
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xl-12 col-md-12" },
                  [
                    _c(
                      "stats-card",
                      {
                        attrs: {
                          title: _vm.model.barang,
                          subTitle: "Total Barang"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "icon-success",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [
                            _c("i", {
                              staticClass: "nc-icon nc-backpack text-success"
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xl-12 col-md-12" },
                  [
                    _c(
                      "stats-card",
                      {
                        attrs: {
                          title: _vm.model.pengunjung,
                          subTitle: "Total Pengunjung"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "icon-danger",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [
                            _c("i", {
                              staticClass: "nc-icon nc-satisfied text-info"
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70ec414c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ec414c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Dashboard.vue
// module id = BDO0
// module chunks = 4